import React from "react";

import { Button, Card, CardContent } from "@/components";
import { useI18n } from "@/context/i18n";

import { usePartnerSelect } from "./partner-select.hooks";

export const PartnerSelectPage: React.FC = () => {
  const { t } = useI18n();
  const { intent, clients, isLoading, isError, onSelectPartner } =
    usePartnerSelect();

  if (!intent) {
    return null;
  }

  return (
    <div className="flex flex-col w-full h-full space-y-6 p-4">
      <div className="flex flex-col px-2">
        <h1 className="text-2xl font-semibold">{t("partnerSelect.title")}</h1>
        <p className="text-muted-foreground text-sm mt-1">
          {t("partnerSelect.description")}
        </p>
      </div>

      {isLoading && (
        <p className="text-sm text-muted-foreground px-2">
          {t("partnerSelect.loading")}
        </p>
      )}

      {isError && (
        <p className="text-sm text-destructive px-2">
          {t("partnerSelect.error")}
        </p>
      )}

      {!isLoading && !isError && clients && clients.length === 0 && (
        <p className="text-sm text-muted-foreground px-2">
          {t("partnerSelect.empty")}
        </p>
      )}

      {!isLoading && !isError && clients && clients.length > 0 && (
        <div className="grid gap-3 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 px-2">
          {clients.map((c) => (
            <Card key={c.id} className="border-border/80">
              <CardContent className="p-4 flex flex-col gap-2">
                <div className="font-medium">{c.name || c.corporate_name}</div>
                {c.corporate_name && c.name && c.corporate_name !== c.name && (
                  <div className="text-xs text-muted-foreground">
                    {c.corporate_name}
                  </div>
                )}
                <Button
                  type="button"
                  variant="secondary"
                  className="w-full mt-2"
                  onClick={() => onSelectPartner(c.id)}
                >
                  {t("partnerSelect.choose")}
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};
